import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { State, PerfilesUsuario, FiltroPractica,  PerfilUsuario} from 'store/usuarios/types';
import { ActionType } from 'typesafe-actions';
import ActionTypes from 'store/usuarios/actionTypes';
import * as actions from 'store/usuarios/actions';
import autoMergeLevel2 from 'redux-persist/es/stateReconciler/autoMergeLevel2';
import { RequestStatusTypes } from 'consts';
import { CursoPractica, Sociedad } from 'store/practicas/types';

export const initialState: State = {
  // Data
  perfilesUsuario: {
    PERFILES: [],
    DATOS_PERFILES_USUARIO: [],
  } as PerfilesUsuario,
  infoUsers: [],
  // Requests statuses
  getPerfilesUsuarioRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  //panel administracion
  getAllUsuariosRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  usuariosAll: [] as PerfilUsuario[],
  getInfoUsersRequestStatus: {
    status: RequestStatusTypes.Default,
  },
 postUsuarioPerfilRequestStatus: {
    status: RequestStatusTypes.Default,
  },
 disabledUsuarioPerfilRequestStatus: {
    status: RequestStatusTypes.Default,
  },

  // User photo
  userPhoto: '',
  updateUserPortraitRquestStatus: {
    status: RequestStatusTypes.Default,
  },
  alumnPhoto: '',
  deleteUserPortraitRquestStatus: {
    status: RequestStatusTypes.Default,
  },
  userPhotoData: {
    CONSENTIMIENTO: '',
    MESSAGE: '',
    PENDIENTE_DE_VALIDAR: '',
    STATUS: '',
    URL_IMAGE: '',
  },
  consentStatus: {
    status: RequestStatusTypes.Default,
  },
  //Filtro
  filtros: [] /* as FiltroPractica[] */,
  filtroId: '',
  nombrePagina: '',
  filtroJson: '',
  nombreFiltro: '',
  fechaCreacion: 0,
  fechaModificacion: 0,
  guardarFiltroRequestStatus: {
    status: RequestStatusTypes.Default,
  },
  editarFiltroRequestStatus: {
    status: RequestStatusTypes.Default
  },
  cursosPracticas: [] as CursoPractica[],
  sociedades: [] as Sociedad[],
};

const reducer = (
  state: State = initialState,
  action: ActionType<typeof actions>
): State => {
  switch (action.type) {
    // Reset reducer
    case ActionTypes.RESET_STATE:
      return initialState;

    // Set reducer
    case ActionTypes.SET_PERFILES_USUARIO:
      return {
        ...state,
        perfilesUsuario: action.payload,
      };
    case ActionTypes.SET_ALL_USUARIOS:
      return { ...state, usuariosAll: action.payload };
    case ActionTypes.SET_GET_ALL_USUARIOS_REQUEST_STATUS:
      return {
        ...state,
        getAllUsuariosRequestStatus: action.payload,
      };
    case ActionTypes.SET_INFO_USERS:
      return {
        ...state,
        infoUsers: action.payload,
      };

    // Requests statuses
    case ActionTypes.SET_GET_PERFILES_USUARIO_REQUEST_STATUS:
      return {
        ...state,
        getPerfilesUsuarioRequestStatus: action.payload,
      };

    case ActionTypes.SET_GET_INFO_USERS_REQUEST_STATUS:
      return {
        ...state,
        getInfoUsersRequestStatus: action.payload,
      };

    // User Photo
    case ActionTypes.SET_USER_PORTRAIT_REQUEST:
      return {
        ...state,
        userPhoto: action.payload,
      };
    case ActionTypes.SET_POST_UPDATE_CONSENT:
      return {
        ...state,
        consentStatus: action.payload,
      };
    case ActionTypes.SET_USER_PORTRAIT_DATA_REQUEST:
      return {
        ...state,
        userPhotoData: action.payload,
      };
    case ActionTypes.UPDATE_USER_PORTRAIT_REQUEST_STATUS:
      return {
        ...state,
        updateUserPortraitRquestStatus: action.payload,
      };
    case ActionTypes.DELETE_USER_PORTRAIT_REQUEST_STATUS:
      return {
        ...state,
        deleteUserPortraitRquestStatus: action.payload,
      };
    case ActionTypes.SET_ALUMN_PORTRAIT_REQUEST:
      return {
        ...state,
        alumnPhoto: action.payload,
      };
    //Filtro
    case ActionTypes.SET_FILTROS:
      return {
        ...state,
        filtros: action.payload,
      };
    case ActionTypes.SET_FILTRO_ID:
      return {
        ...state,
        filtroId: action.payload,
      };
    case ActionTypes.SET_FILTRO_NOMBRE:
      return {
        ...state,
        nombreFiltro: action.payload,
      };
    case ActionTypes.SET_FILTRO_NOMBRE_PAGINA:
      return {
        ...state,
        nombrePagina: action.payload,
      };
    case ActionTypes.SET_FILTRO_FECHA_CREACION:
      return {
        ...state,
        fechaCreacion: action.payload,
      };
    case ActionTypes.SET_FILTRO_FECHA_MODIFICACION:
      return {
        ...state,
        fechaModificacion: action.payload,
      };
    case ActionTypes.SET_FILTRO_JSON:
      return {
        ...state,
        filtroJson: action.payload,
      };
    case ActionTypes.SET_GUARDAR_FILTRO_REQUEST_STATUS:
      return {
        ...state,
        guardarFiltroRequestStatus: action.payload,
      };
    case ActionTypes.SET_EDITAR_FILTRO_REQUEST_STATUS:
      return {
        ...state,
        editarFiltroRequestStatus: action.payload,
      };
    case ActionTypes.REMOVE_FILTRO:
      return {
        ...state,
        filtros: [],
      };
    case ActionTypes.SET_CURSOS_FILTRO:
      return {
        ...state,
        cursosPracticas: [...action.payload],
      };
    case ActionTypes.SET_SOCIEDADES:
      return {
        ...state,
        sociedades: [...action.payload],
      };
    default:
      return state;
  }
};

const persistConfig = {
  key: 'usuarios',
  storage,
  stateReconciler: autoMergeLevel2,
  blacklist: [
    'perfilesUsuario',
    'infoUsers',
    'getPerfilesUsuarioRequestStatus',
    'getInfoUsersRequestStatus',
  ],
};

export default persistReducer(persistConfig, reducer);
